import { z } from 'zod'

/**
 * FO-095 (batch-21) — gedeeld request-schema voor een lichtgewicht aantekening
 * bij een relatie. De API parse't hiermee (`safeParse` → `sendValidationError`)
 * én het backoffice-form valideert er client-side mee vóór versturen, zodat het
 * form niets kan sturen dat de API weigert (CLAUDE.md validatie-conventie).
 *
 * `contactId`/`locationId` zijn optioneel én nullable: weggelaten/`null` = een
 * algemene aantekening; gevuld = een contactpersoon óf locatie van DEZELFDE
 * relatie. De cross-relatie-validatie ("hoort bij dezelfde clientId") is een
 * business-rule en gebeurt server-side in `apps/api/src/routes/client-notes.ts`.
 */
export const CreateClientNoteSchema = z.object({
  content: z.string().trim().min(1, 'Aantekening mag niet leeg zijn'),
  contactId: z.string().min(1).nullable().optional(),
  locationId: z.string().min(1).nullable().optional(),
})
export type CreateClientNoteInput = z.infer<typeof CreateClientNoteSchema>

/** PATCH: alle velden optioneel; read↔write consistent (read geeft de FK's als `null` terug). */
export const UpdateClientNoteSchema = CreateClientNoteSchema.partial()
export type UpdateClientNoteInput = z.infer<typeof UpdateClientNoteSchema>

/**
 * Read-DTO van `GET /clients/:clientId/notes`. Naast de aantekening zelf levert
 * de API de (genullde) `contact`/`location` mee voor de chip-labels in de UI.
 */
export interface ClientNoteDTO {
  id: string
  clientId: string
  authorId: string
  content: string
  contactId: string | null
  locationId: string | null
  createdAt: string
  updatedAt: string
  author: { id: string; name: string | null; email: string | null } | null
  contact: { id: string; firstName: string; lastName: string } | null
  location: { id: string; name: string } | null
}
